module.exports = __webpack_public_path__ + "static/plan-update-category_3-263d16c950c88c8b03336b0770628002.png";